import { render, staticRenderFns } from "./PackageNotesModal.vue?vue&type=template&id=282e6f7f&scoped=true&"
import script from "./PackageNotesModal.vue?vue&type=script&lang=js&"
export * from "./PackageNotesModal.vue?vue&type=script&lang=js&"
import style0 from "./PackageNotesModal.vue?vue&type=style&index=0&id=282e6f7f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "282e6f7f",
  null
  
)

export default component.exports